// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"198":"d8558493","502":"6068a0db","580":"f7d7daff","739":"bee86d55"}[chunkId] + ".chunk.css";
};